import React from 'react'
import Container from '@material-ui/core/Container';
import mapa from '../../assets/mapa3.png';
import lasoñada from '../../assets/lasoñada.svg';


const Section2 = () => {
  return (
    <div id='ubicacion' className='section noPadBot'>
        <Container className='relative flex flexCenter flexCol'> 
        <img className='logoHero' src={lasoñada} alt="Logo Casa Zen" />
        <p className='textCenter'>A partir de su diseño en forma de "L" permite repararse de los vientos fríos y húmedos y al mismo tiempo abrazar gran cantidad de luz otorgando gran luminosidad y confort a sus ambientes.</p>               
          <div className="flex flexCol margtop relative mapa">
            <div className="floatTitle shadow">
              <h2>Ubicación</h2>
              <p>Country Costa del Sol, Lote 239<br />
              Mar Chiquita - Buenos Aires
              </p>

            </div>
              <img src={mapa} alt="Mapa"/>

          </div>
        </Container>
    </div>
  )
}

export default Section2